import classNames from 'clsx';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { selectIsDiscord } from 'src/common/selectors/app';
import { escapeQuery, getSearchUrl } from '../../utils/search/getSearchUrl';
import Input from '../shared/form/Input';
import LegacySearchIcon from '../shared/svgIcons/LegacySearchIcon';
import SearchIcon from '../shared/svgIcons/SearchIcon';
import css from './searchbar.module.scss';

// exported for testing
export function Searchbar({
  useLegacyIcon,
  searchBarClassName,
  initialValue,
  placeholder,
  onChange,
  onFocus,
  onBlur,
  iconContainerClassName,
  autoFocus,
  iconProps,
  hintText,
  history,
  onSubmit,
}) {
  const isDiscord = useSelector(selectIsDiscord);
  const SearchIconComponent = useLegacyIcon ? LegacySearchIcon : SearchIcon;

  const onUserSubmit = useCallback(
    (event, value) => {
      if (!value) {
        return;
      }

      const query = escapeQuery(value);
      history.push(getSearchUrl(query));
      if (onSubmit) onSubmit(value);
    },
    [history, onSubmit],
  );

  const handleKeyDown = useCallback(
    (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        onUserSubmit(event, event.currentTarget.value);
      }
    },
    [onUserSubmit],
  );

  const handleChange = useCallback(
    (event) => {
      onChange?.(event, event.target.value);
    },
    [onChange],
  );

  return (
    <div data-testid="searchBar" className={classNames(css.wrapper, searchBarClassName)}>
      <div className={iconContainerClassName}>
        <SearchIconComponent
          id="searchIcon"
          key="searchIcon"
          dataTestId="searchBarIcon"
          onClick={onUserSubmit}
          {...iconProps}
        />
      </div>
      <Input
        autoFocus={autoFocus}
        id="searchField"
        data-testid="searchBarInput"
        className={clsx(css.field, { [css.discord]: isDiscord })}
        onKeyDown={handleKeyDown}
        onChange={handleChange}
        onFocus={onFocus}
        onBlur={onBlur}
        defaultValue={initialValue}
        key={initialValue}
        placeholder={placeholder ?? hintText}
        autoComplete="off"
        size="lg"
      />
    </div>
  );
}

export default withRouter(Searchbar);

Searchbar.propTypes = {
  history: PropTypes.object.isRequired,
  onSubmit: PropTypes.func,
  useLegacyIcon: PropTypes.bool,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  hintText: PropTypes.string,
  onChange: PropTypes.func,
  initialValue: PropTypes.string,
  autoFocus: PropTypes.bool,
  iconProps: PropTypes.object,
  placeholder: PropTypes.string,
  iconContainerClassName: PropTypes.string,
  searchBarClassName: PropTypes.string,
};
